"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_ACTIVITY_TYPES = exports.SYSTEM_ACTIVITY_TYPES = exports.ACTIVITY_MODULES = void 0;
const ACTIVITY_MODULES = exports.ACTIVITY_MODULES = {
  AUTH: "AUTH",
  BOTTLE_POS: "BOTTLE_POS",
  MPOWER: "MPOWER",
  CLOVER: "CLOVER",
  INVOICE: "INVOICE",
  PAYMENT: "PAYMENT",
  STAMP: "STAMP",
  INVOICE_STAMP: "INVOICE_STAMP"
};
const USER_ACTIVITY_TYPES = exports.USER_ACTIVITY_TYPES = {
  SIGN_IN: "SIGN_IN",
  UPDATE: "UPDATE",
  CREATE: "CREATE",
  DELETE: "DELETE",
  ADD_PRIVATE_NOTE: "ADD_PRIVATE_NOTE",
  DELETE_PRIVATE_NOTE: "DELETE_PRIVATE_NOTE"
};
const SYSTEM_ACTIVITY_TYPES = exports.SYSTEM_ACTIVITY_TYPES = {
  INVOICE_SYNC: "INVOICE_SYNC",
  PRODUCT_SYNC: "PRODUCT_SYNC",
  FEATURE_ON: "FEATURE_ON",
  FEATURE_OFF: "FEATURE_OFF",
  ENABLE: "ENABLE",
  DISABLE: "DISABLE"
};